import React from 'react';
import { formatUtils } from '../../utils/format.utils';
import { OnHoverTooltip } from '../common/OnHoverTooltip';

export function TradedToMe({ price }: { price: number; }){
    const tooltipText = `Traded to me @ ${formatUtils.formatBid(price)}`;
    return <OnHoverTooltip overlay={tooltipText}>Traded to me</OnHoverTooltip>
}